export const i18nHomePage = {
  summary: {
    production: 'Produção',
    uptime: 'Tempo de atividade',
    savings: 'Economia',
    co: 'CO²e',
    so: 'SO²',
    health: 'Saúde',
  },
  card: {
    labels: {
      empty: 'Sem alarmes',
      closed: 'Sem alarmes',
      open: 'Alarmes',
      investigating: 'Investigando',
      no_data: 'Sem dados',
      delay: 'Atraso dos sensores',
      active: 'Sensores OK',
    },
  },
};
